import { motion } from 'framer-motion';
import { Bell, BellRing, Check } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
const NotificationFeatures = () => {
  return <section className="py-16 px-4 bg-medihub-lightPurple">
    <div className="container mx-auto">
      <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.7
      }} className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Értesítési lehetőségek</h2>
          <p className="text-lg text-gray-600">Különböző módon értesülhet az Önt érdeklő eseményekről.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <Card className="overflow-hidden">
            <CardContent className="p-0">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="bg-medihub-primary p-2 rounded-full mr-4">
                    <Bell className="h-5 w-5 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold">E-mail értesítések</h3>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Heti vagy havi összefoglaló a közelgő eseményekről</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Azonnali értesítés új, számodra releváns eseményről</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Emlékeztetők a közelgő rendezvényekről</span>
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>

          <Card className="overflow-hidden">
            <CardContent className="p-0">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="bg-medihub-primary p-2 rounded-full mr-4">
                    <BellRing className="h-5 w-5 text-white" />
                  </div>
                  <h3 className="text-xl font-semibold">Böngésző értesítések</h3>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Értesítések közvetlenül a böngészőben</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Gyors hozzáférés az esemény részleteihez egy kattintással</span>
                  </li>
                  <li className="flex items-start">
                    <Check className="text-medihub-primary h-5 w-5 mt-0.5 mr-2 flex-shrink-0" />
                    <span>Testreszabható értesítési napok és időpontok</span>
                  </li>
                </ul>
              </div>
            </CardContent>
          </Card>
        </div>
      </motion.div>
    </div>
  </section>;
};
export default NotificationFeatures;